import XxTabView from './main.vue';

export default XxTabView;
